exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onedaygroup{background-color:rgba(233,232,248,.5);width:45%;min-height:150px;margin:10px 5px;border-left:4px solid;padding:8px;line-height:1.2}.onedaygroup p{font-size:.9rem}.weekedit{max-height:600px}@media screen and (max-width:1200px){.weekedit{max-height:1800px}.onedaygroup{width:100%;margin:10px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5403cc6c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/LunchOrderItem.vue
// module id = 678
// module chunks = 0